/*
 File: image-aspect.js
 Author: D McCleod
 Created: 2/23/2017
 Modified: 2/23/2017
 Description: add src attribute based on value from data-aspect1 or data-aspect2 (determined by infinite scroll value)
 then append Akamai query string at the end based on media query
 */


import { queryList, checkMediaQuery } from './matchmedia-checker';
const hasInfiniteScroll = slideShowVars.infiniteScroll !== undefined;
let slideImages = $('.crs-slide_image').slice(1);


// infinitescroll uses aspect 2 on breakpoint 1, else use aspect 1
const aspect = hasInfiniteScroll === true ? (breakpoint ===1 ? 'aspect2' : 'aspect1') : 'aspect1';
const dimensionsBase = {
    mq1: '?resize=580:*',
    mq2: '?resize=385:*',
    mq3: '?resize=500:*',
    mq4: '?resize=650:*'
};
const dimensionsLast = {
    mq1: '?resize=200:*',
    mq2: '?resize=150:*',
    mq3: '?resize=183:*',
    mq4: '?resize=300:*'
};
const dimensionsRelated = {
    mq1: '',
    mq2: '?resize=90:*',
    mq3: '?resize=100:*',
    mq4: '?resize=180:*'
};

var imageCount = 0;

// TODO: add query string for retina display - or - as work-around double size of current query

function isLazyLoad(index){
    return index==window.slideShow.initialSlide || (index+1)==window.slideShow.initialSlide || (index-1) == window.slideShow.initialSlide 
}

// populate data-lazy attribute based on data-aspect, then delete the data-aspect attribute.
// Slick's lazyLoad method will handle the src attribute
function addLazyData(){
    
    slideImages.map(function(i, ele){
        let $ele = $(ele);
        //let dataSrc = hasInfiniteScroll ? 'src' : 'data-lazy';
       let dataSrc = i==0 ? 'src' : 'data-src';
        if(!hasInfiniteScroll){
            dataSrc = isLazyLoad(i) ? 'src' : 'data-src';
        }
        // increase imageCount if the image is not part of the related slides
        // used as a pseudo slide count when Slick is not initialized
        if( isNotRelatedSlide($ele)) imageCount++;
        if( hasInfiniteScroll && isNotRelatedSlide($ele)) $ele.parents('.crs-slide').attr('data-slidenumber', i+1 );

        let imgLoc = $ele.data(aspect);
        imgLoc = imgLoc.replace("http://","https://");
        imgLoc = imgLoc.replace(".medscape.com",".medscapestatic.com");
        const dataSrcVal = imgLoc + getAkamaiQuery($ele);

        if(ele.getAttribute('src')==null || ele.getAttribute('src')==''){
            ele.classList.add('lazy-load');
            $ele.one('load',function(e){
                e.target.classList.remove('lazy-load');
            })
        }

        $ele.attr(dataSrc,  dataSrcVal ).removeAttr('data-' + aspect);
        
        return $ele;
    }).promise().done(function(){
        $(window).trigger('lazydata:loaded');
    });
}

// return specific dimension for different slide images
function getDimensionsObj(ele){

    if(ele.siblings('.crs-slide--last_caption').length) {
        return dimensionsLast;
    } else if(ele.siblings('.related-slides_caption').length) {
        return dimensionsRelated;
    } else {
        return dimensionsBase;
    }
}

function getAkamaiQuery(ele){
    // if image is a gif, return empty string, animated gifs are static when query string is appended
    if( isGif(ele.attr('src')) === true ) {
        return '';
    } else {
        let dimensions = getDimensionsObj(ele),
            query = '';

        for(let i in dimensions){
            if( checkMediaQuery(i) ){
                query = dimensions[i];
            }
        }
        return query;
    }
}

function isGif(imgPath){
    let extention;
    let regex = /(?:([^:/?#]+):)?(?:\/\/([^/?#]*))?([^?#]*\.(?:gif))(?:\?([^#]*))?(?:#(.*))?/g;
    extention = regex.test(imgPath);
    return extention;
}


function isNotRelatedSlide(ele){
    return ele.parents('.related-slides').length === 0;
}


export { addLazyData, imageCount };